import { DEFAULT_TEMPLATE } from "../constants";

// The docs link at the bottom of the template frequently gets dropped when the template is
// copied around, so it's ignored when comparing a readme against the template.
const DOCS_LINK_LINE = "[Link to docs](https://docs.merge.dev)";

const normalize = (text: string) =>
  text
    .replace(/\r\n/g, "\n")
    .split("\n")
    .map((line) => line.trimEnd())
    .filter((line) => line !== "" && line !== DOCS_LINK_LINE)
    .join("\n");

const NORMALIZED_DEFAULT_TEMPLATE = normalize(DEFAULT_TEMPLATE);

/**
 * Whether a readme actually says something — i.e. it exists and isn't just the unedited
 * default template that gets pre-filled in the readme editor.
 */
const hasReadmeContent = (text: string | undefined | null): text is string =>
  !!text?.trim() && normalize(text) !== NORMALIZED_DEFAULT_TEMPLATE;

export default hasReadmeContent;
